import { render, staticRenderFns } from "./pickUpCardNew.vue?vue&type=template&id=8ef6dbba&scoped=true&"
import script from "./pickUpCardNew.vue?vue&type=script&lang=js&"
export * from "./pickUpCardNew.vue?vue&type=script&lang=js&"
import style0 from "./pickUpCardNew.vue?vue&type=style&index=0&id=8ef6dbba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef6dbba",
  null
  
)

export default component.exports